// clients/diabete/src/index.js
import ReactDOM from "react-dom/client";
import { Container, CustomProvider } from "rsuite";

import frFR from "rsuite/locales/fr_FR";

import { AuthProvider } from "context/auth-context";
import { ConfigProvider } from "context/config-context";
import { ModalProvider } from "context/modal-context";
import { AlertProvider } from "./context/alert-context";

import App from "./App";
import Modal from "./components/Modal";

import "react-tooltip/dist/react-tooltip.css";
import "rsuite/dist/rsuite.min.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./themes/index.css";
import "./themes/rsuite.custom.css";
import "./themes/yousign.css";

const container = document.getElementById("root");

if (container) {
  const root = ReactDOM.createRoot(container);

  root.render(
    <ConfigProvider>
      <AuthProvider>
        <CustomProvider locale={frFR}>
          <Container>
            <AlertProvider>
              <ModalProvider>
                <App />
                <Modal />
              </ModalProvider>
            </AlertProvider>
          </Container>
        </CustomProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}
